module.exports = __webpack_public_path__ + "f980d7bc8391359e814fc742ae066419.pdf";